/** These strings aren't customer-facing: these don't need to be localized. */
export const ADDED_TO_PLAN = {
  name: 'Cheetah',
  programTitle: 'Why Cheddar Jalapeño Cheetos Are The Best Snack',
  programUrl: 'https://staging.degreed.dev/develop/#/user/program-detail/10000',
  companyLogoUrl:
    'https://static.wikia.nocookie.net/logopedia/images/7/7c/Frito_Lay_logo_1997.svg/revision/latest/scale-to-width-down/200?cb=20210324100506',
};
